@if (asset && quote) {
  <div class="d-flex justify-content-between upper">
    <div class="mr-2">
      {{ asset.name }}
    </div>
    <div>
      @if (direction === 'buy') {
        <span class="quoteindicator-variant5 text-nowrap" zeroBlink [val]="quote.ask"
          >{{ quote.ask | priceScale: asset?.priceScale }}
        </span>
      }
      @if (direction === 'sell') {
        <span class="quoteindicator-variant5 text-nowrap" zeroBlink [val]="quote.bid">
          {{ quote.bid | priceScale: asset?.priceScale }}</span
        >
      }
    </div>
  </div>
  <div class="row lower">
    <div class="col-6">
      {{ isCrypto ? asset.shortName : asset.isin }}
    </div>
    <div class="col-6 text-right">
      {{ quote.time | date: (isQuoteOld ? 'shortDate' : 'mediumTime') }}
    </div>
  </div>
  <hr />
}
